<template>
  <template v-for="renterGroup in renterGroups" :key="renterGroup.title">
    <ShowingRentersCard
      v-if="renterGroup.renters.length > 0"
      :title="renterGroup.title"
      :status="renterGroup.status"
      :property-id="showing.property.id"
      :renters="renterGroup.renters"
    />
  </template>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { AvatarStatus } from '@tallo/design-system';
import {
  getAcceptedRenters,
  getCanceledRenters,
  getDeclinedRenters,
  getExpiredRenters,
  getReschedulingRenters,
  ShowingDto,
} from '@tallo/investor/showing';
import { RenterDto } from '@tallo/renter';

import ShowingRentersCard from './showing-renters-card.vue';

interface RenterGroup {
  title: string;
  status: AvatarStatus;
  renters: RenterDto[];
}

const props = defineProps<{ showing: ShowingDto }>();

const renterGroups = computed<RenterGroup[]>(() => [
  {
    title: 'Confirmed renters',
    status: 'accepted',
    renters: getAcceptedRenters(props.showing),
  },
  {
    title: 'Rescheduling renters',
    status: 'pending',
    renters: getReschedulingRenters(props.showing),
  },
  {
    title: 'Declined renters',
    status: 'declined',
    renters: getDeclinedRenters(props.showing),
  },
  {
    title: 'Canceled renters',
    status: 'declined',
    renters: getCanceledRenters(props.showing),
  },
  {
    title: 'Expired renters',
    status: 'declined',
    renters: getExpiredRenters(props.showing),
  },
]);
</script>
